import React, { useEffect } from 'react';
import { Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { keyBy, omit, mapValues, } from 'lodash';
import { useList, } from 'react-use';

import useFormState from '../hooks/useFormState';
import { isMobile } from '../../util';
import Field from '../Field';
import ListForm from '../ListForm';
import PendingItemForm from '../forms/PendingItemForm';
import { unknownFields as fields, pendingItemFields, } from '../../shared/models/receivingRequest';

const { entries, } = Object;

export default function UnknownReceivingRequestFormModal(props) {
  const { tenant, isOpen, values, tenants = [], onClickClose, admin = false, } = props;
  const [pendingItems, { set: setPendingItem, updateAt: updatePendingItemAt }] = useList(values?.pendingItems || []);
  const statedFields = useFormState(values, fields({ tenants, }), isOpen);
  const isUnsubmittable =
    Object.values(statedFields).some(_ => !_.isValid) ||
    pendingItems.some(_ => !_.isValid);
  const onSubmit = async (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;

    await props.onSubmit({ ...mapValues(statedFields, 'value'), pendingItems: pendingItems.map(_ => omit(_, 'isValid')), });
  };

  return (
    <Modal isOpen={isOpen} style={{ minWidth: !isMobile() && 800 }}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            不明入庫
          </h5>
        </div>
      </div>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <div className="card p-3">
            <ListForm
              addButtonLabel="不明・確認在庫 追加"
              items={pendingItems}
              renderItem={(pendingItem, pendingItemIndex) => {
                return (
                  <div className="card p-3">
                    <PendingItemForm
                      fields={pendingItemFields()}
                      index={pendingItemIndex}
                      values={pendingItem}
                      tenant={tenant}
                      onChange={_ => updatePendingItemAt(pendingItemIndex, { ...pendingItem, ..._, })}
                    />
                  </div>
                );
              }}
              onChange={setPendingItem}
            />
          </div>
          <div className="mt-3">
            {
              entries(statedFields).map(([fieldName, fieldSetting]) => (
                <Field
                  key={fieldName}
                  name={fieldName}
                  {...fieldSetting}
                />
              ))
            }
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
          <Button className="save" type="submit" color="primary" onClick={onSubmit} disabled={isUnsubmittable}>保存</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};
